"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlElementAttributeHandler = void 0;
class HtmlElementAttributeHandler {
    getAttribute(htmlElement, key) {
        const attributeValue = htmlElement.getAttribute(key);
        return attributeValue === null ? undefined : attributeValue;
    }
    setAttribute(htmlElement, key, value) {
        htmlElement.setAttribute(key, value);
    }
    removeAttribute(htmlElement, key) {
        htmlElement.removeAttribute(key);
    }
}
exports.HtmlElementAttributeHandler = HtmlElementAttributeHandler;
